/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AssetCategoryDto } from '../models/AssetCategoryDto';
import type { CreateAssetCategoryRequest } from '../models/CreateAssetCategoryRequest';
import type { Page_AssetCategoryDto_ } from '../models/Page_AssetCategoryDto_';
import type { UpdateAssetCategoryRequest } from '../models/UpdateAssetCategoryRequest';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class AssetCategoryControllerService {
  /**
   * getAssetCategories
   * @returns Page_AssetCategoryDto_ OK
   * @throws ApiError
   */
  public static getAssetCategoriesUsingGet({
    xTenantId,
    limit = 10,
    offset,
    search,
    type,
  }: {
    /**
     * X-TENANT-ID
     */
    xTenantId: string;
    /**
     * limit
     */
    limit?: number;
    /**
     * offset
     */
    offset?: number;
    /**
     * search
     */
    search?: string;
    /**
     * type
     */
    type?: 'CURRENT' | 'NON_CURRENT';
  }): CancelablePromise<Page_AssetCategoryDto_> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/asset-categories',
      headers: {
        'X-TENANT-ID': xTenantId,
      },
      query: {
        limit: limit,
        offset: offset,
        search: search,
        type: type,
      },
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }

  /**
   * create
   * @returns AssetCategoryDto OK
   * @returns any Created
   * @throws ApiError
   */
  public static createUsingPost1({
    request,
    xTenantId,
  }: {
    /**
     * request
     */
    request: CreateAssetCategoryRequest;
    /**
     * X-TENANT-ID
     */
    xTenantId: string;
  }): CancelablePromise<AssetCategoryDto | any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/asset-categories',
      headers: {
        'X-TENANT-ID': xTenantId,
      },
      body: request,
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }

  /**
   * getCategory
   * @returns AssetCategoryDto OK
   * @throws ApiError
   */
  public static getCategoryUsingGet({
    id,
  }: {
    /**
     * id
     */
    id: string;
  }): CancelablePromise<AssetCategoryDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/asset-categories/{id}',
      path: {
        id: id,
      },
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }

  /**
   * updateCategory
   * @returns AssetCategoryDto OK
   * @returns any Created
   * @throws ApiError
   */
  public static updateCategoryUsingPut({
    id,
    request,
  }: {
    /**
     * id
     */
    id: string;
    /**
     * request
     */
    request: UpdateAssetCategoryRequest;
  }): CancelablePromise<AssetCategoryDto | any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/asset-categories/{id}',
      path: {
        id: id,
      },
      body: request,
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }

  /**
   * deleteCategory
   * @returns any OK
   * @throws ApiError
   */
  public static deleteCategoryUsingDelete({
    id,
  }: {
    /**
     * id
     */
    id: string;
  }): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/asset-categories/{id}',
      path: {
        id: id,
      },
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
      },
    });
  }
}
